<template>
  <div class="h-full min-h-screen md:min-h-0 flex flex-col loading">
    <div
      :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
      class="flex-1 md:overflow-y-scroll relative px-10 pt-10"
    >
      <div class="relative z-10">
        <p class="text-xl font-bold text-center mb-6" :style="$themeStyle">
          {{ $t("loadingTitle") }}
        </p>
      </div>
      <div
        class="
               absolute
               h-screen
               md:h-full
               top-0
               left-0
               w-full
               flex flex-col
               justify-center
               items-center
               "
      >
        <AnimationCard id="playlistWithNoteMoving" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'

@Component({
  components: {
  }
})
export default class Loading extends Mixins(TranslationHandler, ThemeHandler) {
  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
  @Getter themeLogoImageUrl!: string
}
</script>
